var map = {
	"./assets/Ellipse 36.png": 649,
	"./assets/Ellipse 37.png": 9472,
	"./assets/Ellipse 38 (1).png": 5,
	"./assets/Ellipse 38.png": 3703,
	"./assets/Frame 35.png": 2025,
	"./assets/InstructorImg.png": 1308,
	"./assets/Leadership.png": 6661,
	"./assets/Mask group (4).png": 8404,
	"./assets/Mask group (5).png": 827,
	"./assets/Mask group (6).png": 6874,
	"./assets/Mask group.png": 3033,
	"./assets/btn (1).png": 3964,
	"./assets/btn (2).png": 6633,
	"./assets/btn.png": 4122,
	"./assets/confirm.png": 7906,
	"./assets/delete.png": 8577,
	"./assets/fonts/Poppins.otf": 5763,
	"./assets/fonts/Sansation_Regular.ttf": 476,
	"./assets/fonts/Satoshi-Regular.otf": 8514,
	"./assets/fonts/calibril.ttf": 7585,
	"./assets/fonts/inter.ttf": 4595,
	"./assets/fonts/micross.ttf": 1483,
	"./assets/fonts/regular.otf": 9414,
	"./assets/fonts/segoe.ttf": 9962,
	"./assets/gallery-add.png": 5558,
	"./assets/guardian.png": 3149,
	"./assets/guardiantwo.png": 6339,
	"./assets/instructors.png": 4542,
	"./assets/inviteEnvelope.png": 8667,
	"./assets/prashant (502) 2 (1).png": 7313,
	"./assets/prashant (502) 2.png": 4931,
	"./assets/profileImg.png": 5832,
	"./assets/studentIcon.png": 1756,
	"./assets/unsplash_QQ9LainS6tI.png": 2540,
	"./components/Notification/NewNotification": 4252,
	"./components/Notification/NewNotification.jsx": 4252,
	"./components/Notification/NotificationDetail": 2241,
	"./components/Notification/NotificationDetail.jsx": 2241,
	"./components/Notification/NotificationList": 2574,
	"./components/Notification/NotificationList.jsx": 2574,
	"./components/Search": 4985,
	"./components/Search.jsx": 4985,
	"./components/Tables": 4528,
	"./components/Tables.jsx": 4528,
	"./components/account-setting/account-setting": 9294,
	"./components/account-setting/account-setting.jsx": 9294,
	"./components/account-setting/login-security": 1464,
	"./components/account-setting/login-security.jsx": 1464,
	"./components/banner/Banner": 1744,
	"./components/banner/Banner.jsx": 1744,
	"./components/button.jsx/Btn": 8999,
	"./components/button.jsx/Btn.jsx": 8999,
	"./components/card": 2145,
	"./components/card.jsx": 2145,
	"./components/layout/Layout": 1332,
	"./components/layout/Layout.jsx": 1332,
	"./components/modal": 4812,
	"./components/modal.jsx": 4812,
	"./components/navbar/Navbar": 8195,
	"./components/navbar/Navbar.jsx": 8195,
	"./components/sidebar/Sidebar": 3535,
	"./components/sidebar/Sidebar.jsx": 3535,
	"./data/Config": 1155,
	"./data/Config.js": 1155,
	"./data/Context": 7010,
	"./data/Context.jsx": 7010,
	"./data/Reducers": 6795,
	"./data/Reducers/": 6795,
	"./data/Reducers/ErrorReducer": 309,
	"./data/Reducers/ErrorReducer.js": 309,
	"./data/Reducers/UserReducer": 3830,
	"./data/Reducers/UserReducer.js": 3830,
	"./data/Reducers/index": 6795,
	"./data/Reducers/index.js": 6795,
	"./data/Store": 5432,
	"./data/Store.js": 5432,
	"./data/Stores/Authstore": 3976,
	"./data/Stores/Authstore.js": 3976,
	"./pages/": 6357,
	"./pages/dashboard": 9320,
	"./pages/dashboard/": 9320,
	"./pages/dashboard/index": 9320,
	"./pages/dashboard/index.jsx": 9320,
	"./pages/guardian": 2841,
	"./pages/guardian/": 2841,
	"./pages/guardian/[id]": 4832,
	"./pages/guardian/[id].jsx": 4832,
	"./pages/guardian/index": 2841,
	"./pages/guardian/index.jsx": 2841,
	"./pages/index": 6357,
	"./pages/index.jsx": 6357,
	"./pages/institution": 8806,
	"./pages/institution/": 8806,
	"./pages/institution/index": 8806,
	"./pages/institution/index.jsx": 8806,
	"./pages/institution/institutionPage": 5361,
	"./pages/institution/institutionPage.jsx": 5361,
	"./pages/instructor": 5865,
	"./pages/instructor/": 5865,
	"./pages/instructor/index": 5865,
	"./pages/instructor/index.jsx": 5865,
	"./pages/instructor/instructorPage": 8429,
	"./pages/instructor/instructorPage.jsx": 8429,
	"./pages/notifications": 4920,
	"./pages/notifications/": 4920,
	"./pages/notifications/index": 4920,
	"./pages/notifications/index.jsx": 4920,
	"./pages/profile-page/Profile-page": 880,
	"./pages/profile-page/Profile-page.jsx": 880,
	"./pages/settings": 3859,
	"./pages/settings/": 3859,
	"./pages/settings/[id]": 4350,
	"./pages/settings/[id].jsx": 4350,
	"./pages/settings/index": 3859,
	"./pages/settings/index.jsx": 3859,
	"./pages/student": 7817,
	"./pages/student/": 7817,
	"./pages/student/[id]": 5792,
	"./pages/student/[id].jsx": 5792,
	"./pages/student/index": 7817,
	"./pages/student/index.jsx": 7817,
	"./screens/home": 2129,
	"./screens/home.jsx": 2129,
	"./screens/login": 9457,
	"./screens/login.jsx": 9457,
	"./style/style.css": 2642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6729;